
export class FiltroListagemDetalheAgrupamentoMensalBilheteModel {
  public ano: string;
  public mes: string;
  public consumidorId: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-listagem-detalhe-agrupamento-mensal-bilhete.model.ts